import { useNavigate } from "react-router-dom";
import React, { useRef, useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import logo from "../assets/logo.png";
import { useLocation } from "react-router-dom";
import down from "../assets/Down.svg";
import ind from "../assets/India.png";
import mala from "../assets/Mala.png";
import dubai from "../assets/Dubai.png";
import { Link } from "react-router-dom";
import london from "../assets/London.png";
import twit from "../assets/Twit.png";
import meeting from "../assets/Meeting.png";
import ti from "../assets/Ti.png";
import trans from "../assets/Transport.svg";
import work from "../assets/Work.svg";
import asset from "../assets/Asset.svg";
import gate from "../assets/Gate.svg";
import sign from "../assets/Sign.svg";
import dock from "../assets/Dock.svg";
import icon from "../assets/Icon.png";
import contact from "../assets/Contact.svg";
import scrab from "../assets/Scrap.svg";
import backg from "../assets/Backg.svg";
import hand from "../assets/Handshake.png";
import free from "../assets/Free.png";
import lap from "../assets/Lap.png";
import trial from "../assets/Trial.png";
import news from "../assets/News.png";
import mail from "../assets/Mail.png";
import insta from "../assets/Insta.png";
import face from "../assets/Facebook.png";
import youtube from "../assets/Youtube.png";
import link from "../assets/Link.png";
import riarr from "../assets/Rightarr.svg";
import phone from "../assets/Phone.png";
import ee from "../assets/Email.png";
import o1 from "../assets/O1.png";
import o2 from "../assets/O2.png";
import o3 from "../assets/O3.png";
import o4 from "../assets/O4.png";
import o5 from "../assets/O5.png";
import nr from "../assets/Nr.png";
import bus from "../assets/Bus.png";
import q from "../assets/Q.png";
import tg from "../assets/Tick.png";
import n from "../assets/N.png";
import right from "../assets/Right.svg";
import coup from "../assets/Coup.png";

const Sayhello = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState("Say Hello");
  const [showDropdown, setShowDropdown] = useState(false);
   const [name, setName] = useState("");
const [email, setEmail] = useState("");
  const [hoveredItem, setHoveredItem] = useState(null);
const [industry, setIndustry] = useState("");
const [message, setMessage] = useState("");
const [selectedService, setSelectedService] = useState("");
const [userCaptcha, setUserCaptcha] = useState("");
const [userCaptchaa, setUserCaptchaa] = useState("");
  


  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 const handleSubmit = async () => {
  try {
    const response = await fetch(
      "https://api-uat.mawalog.com/admin/v2/api/website",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": token,
        },
        body: JSON.stringify({
          session_id: sessionid,
          captcha: userCaptcha,
          name: name,
          email: email,
          industry: industry,
          message: message,
          services: [selectedService],
        }),
      }
    );

    const result = await response.json();
    console.log("Response:", userCaptcha, result);



    setEmail("");
setUserCaptcha("");
setName("");
setMessage("");
setIndustry("");
setSelectedService("");


    toast(result.message);
  } catch (error) {
    console.error("Error sending request:", error);
  }
};


 const handleSubmitt = async () => {
  try {
    const response = await fetch(
      "https://api-uat.mawalog.com/admin/v2/api/website",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": token,
        },
        body: JSON.stringify({
          session_id: sessionid,
          captcha: userCaptcha,
          name: name,
          email: email,
          industry: industry,
          message: message,
          services: [selectedService],
        }),
      }
    );

    const result = await response.json();
    console.log("Response:", userCaptcha, result);



    setEmail("");
setUserCaptcha("");
setName("");
setMessage("");
setIndustry("");
setSelectedService("");


    toast(result.message);
  } catch (error) {
    console.error("Error sending request:", error);
  }
};

  const dropdownItems = [
    {
      title: "LOGISTICS OPERATIONS",
      items: [
        {
          name: "Gate",
          description: (
            <>
              Helps organizations track and manage
              <br />
              visitors efficiently.
            </>
          ),
          icon: gate,
        },
        // {
        //   icon: dock,
        //   name: "Dock",
        //   description:
        //     "Helps businesses streamline loading, unloading & scheduling.",
        // },
        // {
        //   icon: sign,
        //   name: "Signage",
        //   description:
        //     "Creating, managing & displaying digital content on screens.",
        // },
      ],
    },
    // {
    //   title: "TRACKING SYSTEM",
    //   items: [
    //     {
    //       icon: trans,
    //       name: "Transport",
    //       description:
    //         "Helps users efficiently manage & optimize transportation services.",
    //     },
    //     {
    //       icon: bus,
    //       name: "Vehicle Management",
    //       description:
    //         "Tracks vehicles, optimizes routes, and automates expenses.",
    //     },
    //     {
    //       icon: asset,
    //       name: "Asset",
    //       description:
    //         "Helps businesses track, monitor, and manage assets efficiently.",
    //     },
    //   ],
    // },
    {
      title: "WORKFORCE MANAGEMENT",
      items: [
        {
          name: "MeetQ",
          description: (
            <>
              Book & manage meeting rooms
              <br />
              with real-time tracking.
            </>
          ),
          icon: q,
        },
        // {
        //   icon: tg,
        //   name: "TickGo",
        //   description: "Track tasks, log hours, and update statuses.",
        // },
        // {
        //   icon: n,
        //   name: "Nexus",
        //   description: "Manage attendance, tasks, and productivity.",
        // },
      ],
    },
  ];

  const policyRoutes = {
    "Terms and Conditions": "/terms",
    "Privacy Policy": "/privacy",
    "Cookie Policy": "/cookies",
    "Copyright Policy": "/copyright",
  };

  const handleClick = (item) => {
    setActiveItem(item);
    if (item === "Products") {
      setShowDropdown(!showDropdown);
    } else {
      setShowDropdown(false);
    }
    if (item === "Pricing") navigate("/new");
    if (item === "Home") navigate("/");
    if (item === "Say Hello") navigate("/contact");
    if (item === "Partner") navigate("/part");
    if (screenWidth <= 768) setIsMobileMenuOpen(false);
  };

  const cards = [
    {
      title: "Customer Approach or Outreach",
      description: "This occurs when customers initiate contact with our company or we reach out to them.",
      image: hand,
    },
    {
      title: "Virtual Meeting or Direct Site Visit",
      description: "This occurs when customers initiate contact with our company or we reach out to them.",
      image: lap,
    },
    {
      title: "Implementation of Free Trial",
      description: "This occurs when customers initiate contact with our company or we reach out to them.",
      image: free,
    },
  ];

  const [focusedField, setFocusedField] = useState(null);

  const complianceData = [
    { icon: o1, title: "General Data Protection" },
    { icon: o2, title: "SOC2 Compliance Report" },
    { icon: o3, title: "Data Processing Agreement" },
    { icon: o4, title: "ISO Certification" },
    { icon: o5, title: "VAPT Compliance" },
  ];

  const isMobile = screenWidth <= 768;
  const isTablet = screenWidth > 768 && screenWidth <= 1024;
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);



  const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); 
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); 


  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };

  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);

  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }

    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");

   /* ========= characters (extra-uneven, extra-distorted) */
const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];

chars.forEach((ch, i) => {
  // more dramatic randomness
  const angle = (Math.random() - 0.5) * 1.4;      // ±40 °
  const x     = 6 + i * 14 + (Math.random() * 8 - 4);
  const y     = 20 + (Math.random() * 10 - 5);

  ctx.save();
  ctx.translate(x, y);

  /* skew / stretch */
  ctx.transform(
    1 + (Math.random() * 0.2 - 0.1),          // scale-X
    Math.random() * 0.35 - 0.175,             // skew-Y
    Math.random() * 0.35 - 0.175,             // skew-X
    1 + (Math.random() * 0.2 - 0.1),          // scale-Y
    0,
    0
  );

  ctx.rotate(angle);

  /* random font & size */
  ctx.font      = `bold ${18 + Math.floor(Math.random()*6)}px ${fonts[Math.floor(Math.random()*fonts.length)]}`;
  ctx.fillStyle = "#0A3A72";
  ctx.fillText(ch, 0, 0);

  ctx.restore();
});

    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);

  /* -- reload button click ------------------------------------------------------- */
  const handleReload = () => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  const handleSubscribe = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
      setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };


  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);


































  
  const [dataa, setDataa] = useState("");
  const [sessionidd, setSessionidd] = useState("");
  const [tokenn, setTokenn] = useState("");
  useEffect(() => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); 
    }
  }, [data]);
  const handleChangee = (e) => {
    setEmail(e.target.value);
  };

  const canvasReff = useRef(null);
  const [captchaValuee, setCaptchaValuee] = useState(""); 


  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptchaa = async () => {
    try {
      const res = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };

  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);

  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasReff.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }

    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");

   /* ========= characters (extra-uneven, extra-distorted) */
const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];

chars.forEach((ch, i) => {
  // more dramatic randomness
  const angle = (Math.random() - 0.5) * 1.4;      // ±40 °
  const x     = 6 + i * 14 + (Math.random() * 8 - 4);
  const y     = 20 + (Math.random() * 10 - 5);

  ctx.save();
  ctx.translate(x, y);

  /* skew / stretch */
  ctx.transform(
    1 + (Math.random() * 0.2 - 0.1),          // scale-X
    Math.random() * 0.35 - 0.175,             // skew-Y
    Math.random() * 0.35 - 0.175,             // skew-X
    1 + (Math.random() * 0.2 - 0.1),          // scale-Y
    0,
    0
  );

  ctx.rotate(angle);

  /* random font & size */
  ctx.font      = `bold ${18 + Math.floor(Math.random()*6)}px ${fonts[Math.floor(Math.random()*fonts.length)]}`;
  ctx.fillStyle = "#0A3A72";
  ctx.fillText(ch, 0, 0);

  ctx.restore();
});

    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);

  /* -- reload button click ------------------------------------------------------- */
  const handleReloadd = () => {
    fetch("https://api-uat.mawalog.com/admin/v2/api/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  const handleSubscribee = async () => {
    try {
      const response = await fetch(
        "https://api-uat.mawalog.com/admin/v2/api/newsletter",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": token,
          },
          body: JSON.stringify({
            session_id: sessionid,
            captcha: userCaptcha,
            email: email,
            type: "Mawalog",
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", userCaptcha, " ", data);
      setEmail("");
      setUserCaptcha("");
      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };


  const locationn = useLocation();
  useEffect(() => {
    if (locationn.hash) {
      setTimeout(() => {
        const el = document.getElementById(locationn.hash.replace("#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location]);


  return (
    <div >
            <ToastContainer
       position="bottom-right"
       autoClose={3000}
       style={{ bottom: "80px" }}
     />
      {/* Floating Button */}
      {/* <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          position: "fixed",
          bottom: isMobile ? "20px" : "40px",
          right: isMobile ? "10px" : "20px",
          zIndex: 20,
        }}
      >
        <button style={{ padding: 0, background: "transparent", border: "none", cursor: "pointer" }}>
          <img src={icon} alt="button icon" style={{ width: isMobile ? "45px" : "55px", height: isMobile ? "45px" : "55px" }} />
        </button>
      </div> */}

  <>
          <div
    style={{
      fontFamily: "Epilogue",
      lineHeight: "1.4",
      top: 0,
      zIndex: 1000,
      display: "flex",
      position: "sticky",
      justifyContent: "space-between",
      alignItems: "center",
      padding: isMobile ? "10px 3%" : "0px 5%",
      backgroundColor: "#fff",
      flexWrap: "wrap",
       borderBottom: "1px solid #ddd",
    }}
  >
  
  <div
    onClick={() => {
      if (window.location.pathname === "/") {
        window.location.reload();
      } else {
        window.location.href = "/";
      }
    }}
    style={{ cursor: "pointer" }}
  >
    <img
      src={logo}
      alt="Logo"
      style={{
        maxWidth: isMobile ? "120px" : "150px",
        height: "auto",
        marginLeft: isMobile ? "-10px" : "-50px",
      }}
    />
  </div>
  
     
             {/* Mobile Hamburger Icon */}
             {isMobile && (
               <button
                 onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                 style={{ background: "none", border: "none", cursor: "pointer" }}
               >
                 <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                 </svg>
               </button>
             )}
     
             {/* Desktop/Tablet Menu */}
             {!isMobile && (
               <div
                 style={{
                   display: "flex",
                   alignItems: "center",
                   gap: "8px",
                   flexDirection: "row",
                   width: "auto",
                   backgroundColor: "transparent",
                   padding: "0",
                 }}
               >
  {["Products", "Partner", "Say Hello"].map((item, index) => (
          <div
            key={index}
            style={{ position: "relative", width: "auto" }}
            onMouseEnter={() => {
              setHoveredItem(item);
              if (item === "Products") setShowDropdown(true);
            }}
            onMouseLeave={() => {
              setHoveredItem(null);
              if (item === "Products") setShowDropdown(false);
            }}
          >
            <div
              onClick={() => handleClick(item)}
              style={{
                fontSize: "clamp(12px, 2vw, 16px)",
                cursor: "pointer",
                fontWeight: "normal",
                backgroundColor:
                  activeItem === item || hoveredItem === item
                    ? "#EAF3FF"
                    : "transparent",
                padding: "8px 16px",
                borderRadius: "20px",
                transition: "background-color 0.3s",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                justifyContent: "flex-start",
              }}
            >
              {item}
              {item === "Products" && (
                <img
                  src={down}
                  alt="Down Arrow"
                  style={{
                    width: "10px",
                    height: "7px",
                    transform: showDropdown ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                />
              )}
            </div>
  
            {item === "Products" && showDropdown && (
              <div
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
                style={{
                  position: "fixed",
                  top: 30,
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 9999,
                  marginTop: "20px",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  borderRadius: "24px",
                  overflow: "hidden",
                  width: "min(980px, 90vw)",
                  maxWidth: "100%",
                  padding: "16px",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "16px",
                  boxSizing: "border-box",
                }}
              >
                {dropdownItems.map((section, i) => (
                  <div
                    key={i}
                    style={{
                      paddingRight:
                        i < dropdownItems.length - 1 ? "16px" : undefined,
                      borderRight:
                        i < dropdownItems.length - 1
                          ? "1px solid #E0E0E0"
                          : "none",
                    }}
                  >
                    <div
                      style={{
                        color: "#666",
                        fontWeight: 600,
                        marginBottom: 12,
                        textTransform: "uppercase",
                        fontSize: 12,
                      }}
                    >
                      {section.title}
                    </div>
  
                    {section.items.map((product, j) => (
                      <div
                        key={j}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 10,
                          padding: "8px",
                          cursor: "pointer",
                          marginBottom: 8,
                          borderRadius: 8,
                          transition: "background-color 0.3s ease",
                        }}
                        onClick={() => {
                          if (product.name === "Gate") navigate("/gate");
                          else if (product.name === "MeetQ") navigate("/meetq");
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#F0F8FF";
                          const name = e.currentTarget.querySelector(
                            ".product-name"
                          );
                          const arrow = e.currentTarget.querySelector(".arrow-icon");
                          if (name) name.style.color = "#004aad";
                          if (arrow) {
                            arrow.style.filter =
                              "brightness(0) saturate(100%) invert(17%) sepia(99%) saturate(746%) hue-rotate(197deg) brightness(94%) contrast(100%)";
                            arrow.style.transform = "translateX(4px)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "transparent";
                          const name = e.currentTarget.querySelector(
                            ".product-name"
                          );
                          const arrow = e.currentTarget.querySelector(".arrow-icon");
                          if (name) name.style.color = "inherit";
                          if (arrow) {
                            arrow.style.filter = "none";
                            arrow.style.transform = "translateX(0)";
                          }
                        }}
                      >
                        <img
                          src={product.icon}
                          alt={product.name}
                          style={{ width: 20, height: 20 }}
                        />
                        <div>
                          <div
                            className="product-name"
                            style={{
                              fontWeight: 600,
                              display: "flex",
                              alignItems: "center",
                              transition: "color 0.3s ease",
                              fontSize: 13,
                            }}
                          >
                            {product.name}
                            <img
                              className="arrow-icon"
                              src={nr}
                              alt="arrow"
                              style={{
                                marginLeft: 4,
                                width: 16,
                                height: 16,
                                transition: "filter 0.3s ease, transform 0.3s ease",
                              }}
                            />
                          </div>
                          <div
                            style={{
                              color: "#666",
                              fontSize: 12,
                              textAlign: "left",
                              lineHeight: 1.4,
                            }}
                          >
                            {product.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
  
     
                 <div style={{ display: "flex", justifyContent: "end", gap: "8px" }}>
                   <button
    onClick={() => window.open("http://app.mawalog.com/login", "_blank")}
    className="login-button"
    style={{
      padding: "10px 20px",
      borderRadius: "20px",
      border: "1px solid #004aad",
      backgroundColor: "#fff",
      color: "#004aad",
      fontWeight: "bold",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
  >
    Login
  </button>
  
                   <button
                     onClick={() => window.open("https://app.mawalog.com/register", "_blank")}
                     className="register-button"
                     style={{
                       padding: "10px 20px",
                       borderRadius: "20px",
                       border: "none",
                       backgroundColor: "#004aad",
                       color: "#fff",
                       fontWeight: "bold",
                       cursor: "pointer",
                       fontSize: "16px",
                       transition: "background-color 0.3s",
                     }}
                     onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                     onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                   >
                     Register
                   </button>
                 </div>
               </div>
             )}
           </div>
     
           {/* Mobile Menu */}
           {isMobile && isMobileMenuOpen && (
             <div
               style={{
                 position: "fixed",
                 top: 0,
                 left: 0,
                 width: "100%",
                 height: "100%",
                 backgroundColor: "#fff",
                 padding: "20px",
                 overflowY: "auto",
                 zIndex: 1001,
                 boxSizing: "border-box",
                 fontFamily: "Epilogue, sans-serif",
               }}
             >
               {/* Header with Logo and Close Button */}
               <div
                 style={{
                   display: "flex",
                   justifyContent: "space-between",
                   alignItems: "center",
                   marginBottom: "20px",
                 }}
               >
                 <Link to="/">
    <img
      src={logo}
      alt="Logo"
      style={{ width: "120px", height: "auto", cursor: "pointer" }}
    />
  </Link>
                 <button
                   onClick={() => setIsMobileMenuOpen(false)}
                   style={{ background: "none", border: "none", cursor: "pointer" }}
                 >
                   <svg width="24" height="24" fill="none" stroke="#181835" strokeWidth="2" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                   </svg>
                 </button>
               </div>
     
               {/* Navigation Items */}
               {["Products", "Partner", "Say Hello"].map((item, index) => (
                 <div key={index} style={{ marginBottom: "12px", width: "100%" }}>
                   {item === "Products" ? (
                     <>
                       <div
                         onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
                         style={{
                           fontSize: "16px",
                           cursor: "pointer",
                           fontWeight: "600",
                           color: "#004aad",
                           padding: "12px",
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                           borderRadius: "8px",
                           transition: "background-color 0.3s",
                           textAlign: "center",
                         }}
                         onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                         onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                       >
                         Products
                         <img
                           src={down}
                           alt="Arrow"
                           style={{
                             width: "10px",
                             height: "7px",
                             transform: mobileProductsOpen ? "rotate(180deg)" : "rotate(0deg)",
                             transition: "transform 0.3s",
                           }}
                         />
                       </div>
                       {mobileProductsOpen && (
                         <div
                           style={{
                             marginTop: "12px",
                             padding: "16px",
                             backgroundColor: "#F9FAFB",
                             borderRadius: "12px",
                             display: "flex",
                             flexDirection: "column",
                             gap: "16px",
                             maxWidth: "100%",
                             overflow: "auto",
                             boxSizing: "border-box",
                             justifyContent: "center",
                             alignItems: "center",
                             textAlign: "center",
                           }}
                         >
                           {dropdownItems.map((section, i) => (
                             <div key={i} style={{ marginBottom: "16px", width: "100%", maxWidth: "90%" }}>
                               <div
                                 style={{
                                   color: "#666",
                                   fontWeight: "600",
                                   textTransform: "uppercase",
                                   fontSize: "12px",
                                   marginBottom: "8px",
                                 }}
                               >
                                 {section.title}
                               </div>
                               {section.items.map((product, j) => (
                                 <div
                                   key={j}
                                   style={{
                                     display: "flex",
                                     flexDirection: "column",
                                     alignItems: "center",
                                     gap: "8px",
                                     padding: "8px",
                                     cursor: "pointer",
                                     borderRadius: "8px",
                                     transition: "background-color 0.3s ease",
                                     maxWidth: "100%",
                                   }}
                                   onClick={() => {
                                     if (product.name === "Gate") navigate("/gate");
                                     else if (product.name === "MeetQ") navigate("/meetq");
                                     setIsMobileMenuOpen(false);
                                   }}
                                   onMouseEnter={(e) => {
                                     e.currentTarget.style.backgroundColor = "#F0F8FF";
                                     const name = e.currentTarget.querySelector(".product-name");
                                     name.style.color = "#004aad";
                                   }}
                                   onMouseLeave={(e) => {
                                     e.currentTarget.style.backgroundColor = "transparent";
                                     const name = e.currentTarget.querySelector(".product-name");
                                     name.style.color = "inherit";
                                   }}
                                 >
                                   <img src={product.icon} alt={product.name} style={{ width: "20px", height: "20px" }} />
                                   <div style={{ flex: 1, overflow: "hidden" }}>
                                     <div
                                       className="product-name"
                                       style={{
                                         fontWeight: "600",
                                         fontSize: "14px",
                                         transition: "color 0.3s ease",
                                         whiteSpace: "normal",
                                         overflow: "hidden",
                                         textOverflow: "ellipsis",
                                         textAlign: "center",
                                       }}
                                     >
                                       {product.name}
                                     </div>
                                     <div
                                       style={{
                                         color: "#666",
                                         fontSize: "12px",
                                         lineHeight: "1.4",
                                         overflowWrap: "break-word",
                                         textAlign: "center",
                                       }}
                                     >
                                       {product.description}
                                     </div>
                                   </div>
                                 </div>
                               ))}
                             </div>
                           ))}
                           <a
                             href="#"
                             style={{
                               color: "#004aad",
                               fontWeight: "600",
                               fontSize: "14px",
                               textDecoration: "none",
                               display: "inline-flex",
                               alignItems: "center",
                               padding: "8px",
                             }}
                             onClick={() => setIsMobileMenuOpen(false)}
                           >
                             Explore all products
                             <img
                               src={right}
                               alt="arrow"
                               style={{
                                 marginLeft: "4px",
                                 width: "16px",
                                 height: "16px",
                                 verticalAlign: "middle",
                               }}
                             />
                           </a>
                         </div>
                       )}
                     </>
                   ) : (
                     <div
                       onClick={() => {
                         handleClick(item);
                         setIsMobileMenuOpen(false);
                       }}
                       style={{
                         fontSize: "16px",
                         cursor: "pointer",
                         fontWeight: "600",
                         color: "#004aad",
                         padding: "12px",
                         borderRadius: "8px",
                         transition: "background-color 0.3s",
                         textAlign: "center",
                       }}
                       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F0F8FF")}
                       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                     >
                       {item}
                     </div>
                   )}
                 </div>
               ))}
     
               {/* Buttons */}
               <div
                 style={{
                   display: "flex",
                   flexDirection: "column",
                   gap: "12px",
                   width: "100%",
                   marginTop: "20px",
                 }}
               >
                 <button
                   onClick={() => {
                     window.location.href = "http://app.mawalog.com/login";
                     setIsMobileMenuOpen(false);
                   }}
                   style={{
                     padding: "8px 16px",
                     borderRadius: "20px",
                     border: "1px solid #004aad",
                     backgroundColor: "#fff",
                     color: "#004aad",
                     fontWeight: "bold",
                     cursor: "pointer",
                     fontSize: "14px",
                     width: "100%",
                     transition: "background-color 0.3s",
                   }}
                   onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f4ff")}
                   onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
                 >
                   Login
                 </button>
                 <button
                   onClick={() => {
                     window.open("https://app.mawalog.com/register", "_blank");
                     setIsMobileMenuOpen(false);
                   }}
                   style={{
                     padding: "8px 16px",
                     borderRadius: "20px",
                     border: "none",
                     backgroundColor: "#004aad",
                     color: "#fff",
                     fontWeight: "bold",
                     cursor: "pointer",
                     fontSize: "14px",
                     width: "100%",
                     transition: "background-color 0.3s",
                   }}
                   onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#003a94")}
                   onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#004aad")}
                 >
                   Register
                 </button>
               </div>
             </div>
           )}
     
           {/* Media Queries for Tablet Button Size */}
           <style>
             {`
               @media (min-width: 769px) and (max-width: 1024px) {
                 .login-button, .register-button {
                   padding: 8px 16px !important;
                   font-size: 14px !important;
                 }
               }
             `}
           </style>
         </>

      {/* Hero Section */}
      <div
        style={{
          fontFamily: "Epilogue",
          lineHeight: "1.4",
          height: isMobile ? "100px" : isTablet ? "110px" : "120px",
          textAlign: "center",
          padding: isMobile ? "20px 10px" : "50px 20px",
          backgroundImage: `url(${backg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          style={{
            fontSize: isMobile ? "30px" : isTablet ? "40px" : "50px",
            fontWeight: "bold",
            color: "#181835",
            marginBottom: isMobile ? "-20px" : "-40px",
          }}
        >
          Welcome to Mawalog!
        </div>
        <div
          style={{
            fontSize: isMobile ? "12px" : "15px",
            marginTop: isMobile ? "30px" : "50px",
            color: "#5A5A5A",
          }}
        >
          What we can do for you? We're always here to assist you.
        </div>
      </div>

      {/* Contact Us Section */}
      <div style={{ fontFamily: "Epilouge" }}>
        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            maxWidth: "1200px",
            margin: "0 auto",
            padding: isMobile ? "0 10px" : "0 20px",
          }}
        >
          <div
            style={{
              fontSize: isMobile ? "24px" : isTablet ? "30px" : "36px",
              fontWeight: "bold",
              color: "#181835",
              marginLeft: "40px",
            }}
          >
            Contact us
          </div>
        </div>

        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            maxWidth: "1200px",
            margin: "0 auto",
            padding: isMobile ? "0 10px" : "0 20px",
            marginTop: "24px",
          }}
        >
          <div
            style={{
              fontSize: isMobile ? "14px" : "16px",
              color: "#5A5A5A",
              maxWidth: isMobile ? "100%" : "600px",
              marginLeft: "40px",
            }}
          >
            Give us a call or drop by anytime, we endeavor to answer all enquiries within 24 hours on business days. We will be happy to answer your questions.
          </div>
        </div>

        {/* Contact Box */}
        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            backgroundColor: "#F9F9F9",
            borderRadius: "12px",
            padding: isMobile ? "15px" : "20px",
            marginTop: "30px",
            marginLeft: "auto",
            marginRight: "auto",
            maxWidth: isMobile ? "100%" : isTablet ? "800px" : "1000px",
          }}
        >
          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              fontWeight: "bold",
              color: "#181835",
              paddingLeft: "10px",
            }}
          >
            For support enquiries
          </h3>

          <div
  style={{
    display: "flex",
    flexWrap: "wrap",
    rowGap: "20px",
    columnGap: isMobile ? "0" : "100px",
    marginTop: "20px",
    paddingLeft: "10px",
  }}
>
  {/* Row 1: India, Malaysia, Dubai */}
  {[
    { img: ind, name: "India", phone: "+91-44-4856-3345" },
    { img: mala, name: "Malaysia", phone: "603-27700-311" },
    { img: dubai, name: "Dubai", phone: "603-27700-311" },
  ].map((country, index) => (
    <div
      key={index}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        width: isMobile ? "100%" : "auto",
      }}
    >
      <img
        src={country.img}
        alt={country.name}
        style={{
          width: isMobile ? "50px" : "60px",
          height: isMobile ? "36px" : "44px",
        }}
      />
      <div>
        <strong>{country.name}</strong>
        <p style={{ margin: 0 }}>
          <a
            href={`tel:${country.phone}`}
            style={{ color: "#5A5A5A", textDecoration: "none" }}
          >
            {country.phone}
          </a>
        </p>
      </div>
    </div>
  ))}

  {/* Row 2: London */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      width: isMobile ? "100%" : "auto",
      marginLeft: isMobile ? "0" : "0px",
      marginTop: isMobile ? "0" : "10px",
    }}
  >
    <img
      src={london}
      alt="London"
      style={{
        width: isMobile ? "50px" : "60px",
        height: isMobile ? "36px" : "44px",
      }}
    />
    <div>
      <strong>London</strong>
      <p style={{ margin: 0 }}>
        <a
          href="tel:603-27700-311"
          style={{ color: "#5A5A5A", textDecoration: "none" }}
        >
          603-27700-311
        </a>
      </p>
    </div>
  </div>
</div>

        </div>


        {/* Enquiry Section */}
        <div style={{ background: "#FAFAFA" }}>
          <div
            style={{
              fontFamily: "Epilogue",
              lineHeight: "1.4",
              display: "flex",
              justifyContent: "space-between",
              padding: isMobile ? "20px 10px" : "20px",
              maxWidth: "1400px",
              margin: "50px auto",
              flexWrap: "wrap",
              boxSizing: "border-box",
            }}
          >
            <div>
              <div
                style={{
                  fontFamily: "Epilogue",
                  lineHeight: "1.4",
                  marginLeft: isMobile ? "10px" : "30px",
                  fontWeight: "bold",
                  fontSize: isMobile ? "20px" : isTablet ? "24px" : "clamp(26px, 2.5vw, 32px)",
                  marginTop: isMobile ? "20px" : "100px",
                  width: "fit-content",
                }}
              >
                Make an Enquiry
              </div>
              <div
                style={{
                  fontFamily: "Epilogue",
                  lineHeight: "1.4",
                  marginTop: "10px",
                  fontSize: isMobile ? "10px" : "12px",
                  marginLeft: isMobile ? "10px" : "20px",
                  width: "fit-content",
                  color: "#616161",
                }}
              >
                Select a product from the list to explore its features, <br />
                benefits, and how it can help you.
              </div>
              <img
                src={coup}
                alt="Enquiry Illustration"
                style={{
                  width: isMobile ? "200px" : isTablet ? "250px" : "clamp(250px, 25vw, 400px)",
                  height: "auto",
                  marginTop: "30px",
                  marginLeft: isMobile ? "10px" : "20px",
                }}
              />
            </div>

            <div
              id="contact-form-section"
              style={{
                backgroundColor: "#fff",
                borderRadius: "40px",
                border: "2px solid #F2F2F2",
                padding: isMobile ? "20px" : "40px",
                maxWidth: isMobile ? "100%" : isTablet ? "600px" : "800px",
                width: isMobile ? "100%" : "90%",
                marginTop: "40px",
                marginBottom: "40px",
                marginLeft: "auto",
                marginRight: "auto",
                transform: !isMobile && !isTablet ? "translateX(30px)" : "none",
                boxSizing: "border-box",
              }}
            >
              <h2
                style={{
                  fontSize: isMobile ? "22px" : isTablet ? "26px" : "28px",
                  fontWeight: "bold",
                  color: "#181835",
                  margin: "0",
                }}
              >
                Get in touch with us
              </h2>
              <p
                style={{
                  fontSize: isMobile ? "14px" : "16px",
                  color: "#5A5A5A",
                  marginBottom: "20px",
                }}
              >
                Ready to Get Started
              </p>

              <input
                type="text"
                placeholder="Your name"
                onFocus={() => setFocusedField("name")}
                onBlur={() => setFocusedField(null)}
                onChange={(e) => setName(e.target.value)}
                style={{
                  width: "100%",
                  padding: isMobile ? "10px" : "12px",
                  fontSize: isMobile ? "14px" : "16px",
                  border:
                    focusedField === "name" ? "2px solid #004AAD" : "1px solid #DADADA",
                  borderRadius: "8px",
                  outline: "none",
                  marginBottom: "15px",
                  boxSizing: "border-box",
                }}
              />


              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                  gap: "10px",
                  marginBottom: "15px",
                }}
              >
                <input
                  type="email"
                  placeholder="Email"
                  onFocus={() => setFocusedField("email")}
                  onBlur={() => setFocusedField(null)}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    width: "100%",
                    padding: isMobile ? "10px" : "12px",
                    fontSize: isMobile ? "14px" : "16px",
                    border:
                      focusedField === "email"
                        ? "2px solid #004AAD"
                        : "1px solid #DADADA",
                    borderRadius: "8px",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
                <select
                  onFocus={() => setFocusedField("industry")}
                  onBlur={() => setFocusedField(null)}
                  onChange={(e) => setIndustry(e.target.value)}
                  style={{
                    width: "100%",
                    padding: isMobile ? "10px" : "12px",
                    fontSize: isMobile ? "14px" : "16px",
                    border:
                      focusedField === "industry"
                        ? "2px solid #004AAD"
                        : "1px solid #DADADA",
                    borderRadius: "8px",
                    outline: "none",
                    backgroundColor: "white",
                    color: "#5A5A5A",
                    boxSizing: "border-box",
                  }}
                >
                  <option>Industry</option>
                  <option>Technology</option>
                  <option>Finance</option>
                  <option>Healthcare</option>
                </select>
              </div>

           <textarea
  placeholder="Message"
  onFocus={() => setFocusedField("message")}
  onBlur={() => setFocusedField(null)}
  onChange={(e) => setMessage(e.target.value)}
  style={{
    width: "100%",
    padding: isMobile ? "10px" : "12px",
    fontSize: isMobile ? "14px" : "16px",
    fontFamily: "inherit", // <-- Add this line
    border:
      focusedField === "message"
        ? "2px solid #004AAD"
        : "1px solid #DADADA",
    borderRadius: "8px",
    outline: "none",
    minHeight: "80px",
    boxSizing: "border-box",
    marginBottom: "20px",
  }}
/>


              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <h3
                  style={{
                    fontSize: isMobile ? "18px" : "20px",
                    fontWeight: "bold",
                    color: "#181835",
                    textAlign: "left",
                    marginBottom: "15px",
                  }}
                >
                  Select your services
                </h3>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: isMobile
                      ? "repeat(2, minmax(0, 1fr))"
                      : isTablet
                        ? "repeat(3, minmax(0, 1fr))"
                        : "repeat(5, minmax(0, 1fr))",
                    gap: "12px",
                  }}
                >
                  {[{ img: gate, label: "Gate" }, { img: q, label: "MeetQ" }].map(
                    (service, index) => (
                      <div
                        key={index}
                        onClick={() => setSelectedService(service.label)}
                        style={{
                          backgroundColor: "#FAFAFA",
                          borderRadius: "16px",
                          padding: isMobile ? "8px" : "10px 14px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: isMobile ? "70px" : "80px",
                          transition: "all 0.3s ease",
                          cursor: "pointer",
                        }}

                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.08)";
                          e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <img
                          src={service.img}
                          alt={service.label}
                          style={{
                            width: isMobile ? "25px" : "30px",
                            height: isMobile ? "25px" : "30px",
                            objectFit: "contain",
                            marginBottom: "6px",
                            transition: "transform 0.3s ease",
                          }}
                        />
                        <p
                          style={{
                            fontSize: isMobile ? "11px" : "13px",
                            color: "#333",
                            margin: 0,
                          }}
                        >
                          {service.label}
                        </p>
                      </div>
                    )
                  )}
                </div>

                {/* CAPTCHA + RELOAD + INPUT FIELD BELOW */}
                 <>
            <style>{`
        .captchaa-container {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 10px auto !important;
          gap: 10px !important;
          flex-wrap: wrap !important;
        }
        .captchaa-box {
          width: 60px !important;
          height: 40px !important;
          border-radius: 20px !important;        
          background-color: #fff !important;
          box-shadow: 0 0 6px rgba(0, 0, 0, 0.1) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .captchaa-input {
          padding:10px 1px!important;
          border-radius:8px!important;
          border:2px solid #000!important;
          outline:none!important;
          min-width:120px!important;
          background:#fff!important;
          color:#000!important;
        }
        .subscribee-button {
          padding:14px 30px!important;
          border-radius:12px!important;
          border:none!important;
          background:#fff!important;
          color:#0A3A72!important;
          font-weight:bold!important;
          cursor:pointer!important;
          margin-bottom:0!important;
        }
        @media(max-width:1024px){ .captchaa-container{margin-left:50px!important;} .captchaa-input{min-width:110px!important;} }
        @media(max-width:768px ){ .captchaa-container{margin-left:40px!important;} .captchaa-input{min-width:100px!important;} }
        @media(max-width:480px ){ .captchaa-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captchaa-input{min-width:80px!important;font-size:14px!important;} }
      `}</style>

            <div className="captchaa-container">
              <div className="captchaa-box">
                <canvas
                  ref={canvasReff}
                  id="captchaCanvas"
                  width={60}
                  height={40}
                />
              </div>

              <button
                onClick={handleReloadd}
                style={{
                  background: "#2563EB",
                  color: "#fff",
                  border: "none",
                  padding: "8px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Your reload SVG icon here */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                </svg>
              </button>

              <input
                type="text"
                placeholder="Enter captcha"
                value={userCaptchaa}
                onChange={(e) => setUserCaptchaa(e.target.value)}
                className="captchaa-input"
              />
            

                <div
                  style={{ display: "flex", justifyContent: "center"}}
                >
                  <button
                    style={{
                      backgroundColor: "#004AAD",
                      color: "white",
                      fontSize: isMobile ? "14px" : "16px",
                      fontWeight: "bold",
                      padding: isMobile ? "10px 20px" : "12px 28px",
                      borderRadius: "12px",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={handleSubmitt}
                  >
                    Submit
                  </button>
                </div>
            </div>
          </>
             
              </div>
            </div>
          </div>

          {/* Expect From Us Section */}
          <div
            style={{
              fontFamily: "Epilogue",
              lineHeight: "1.4",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              maxWidth: "1100px",
              margin: "0 auto",
              padding: isMobile ? "30px 10px" : "50px 20px",
              flexWrap: isMobile ? "wrap" : "nowrap",
            }}
          >
            <div style={{ maxWidth: isMobile ? "100%" : "500px" }}>
              <p
                style={{
                  color: "#004AAD",
                  fontSize: isMobile ? "12px" : "14px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  marginLeft: isMobile ? "20px" : "70px",  // reduced marginLeft for small screens
                }}
              >
                OUR GESTURES
              </p>
              <h2
                style={{
                  fontSize: isMobile ? "22px" : isTablet ? "28px" : "32px",
                  fontWeight: "bold",
                  color: "#181835",
                  marginBottom: "20px",
                  marginLeft: isMobile ? "20px" : "70px",  // reduced marginLeft for small screens
                }}
              >
                What to expect from us
              </h2>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                  marginLeft: isMobile ? "20px" : "70px",  // reduced marginLeft for small screens
                }}
              >
                {[
                  "Minimum chat with a solutions specialist",
                  "Commitment-free consultation on your top needs and challenges",
                  "Discover product capabilities and how Mawalog may help",
                ].map((text, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", alignItems: "center", gap: "12px" }}
                  >
                    <img
                      src={ti}
                      alt="Check"
                      style={{
                        width: isMobile ? "18px" : "24px",
                        height: isMobile ? "18px" : "24px",
                      }}
                    />
                    <p
                      style={{
                        fontSize: isMobile ? "14px" : "18px",
                        color: "#333",
                        margin: "0",
                      }}
                    >
                      {text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div
              style={{
                position: "relative",
                marginRight: isMobile ? "0" : "80px",
                overflow: "hidden",
                marginTop: isMobile ? "20px" : "0",
                width: isMobile ? "100%" : "auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img
                src={meeting}
                alt="Business Meeting"
                style={{
                  width: isMobile ? "100%" : isTablet ? "300px" : "350px",
                  height: isMobile ? "auto" : isTablet ? "200px" : "250px",
                  maxWidth: "350px",
                  animation: "slideLeftFade 5s ease-in-out infinite",
                }}
              />
              <style>
                {`
        @keyframes slideLeftFade {
          0% { transform: translateX(-100px); opacity: 0; }
          10% { transform: translateX(0); opacity: 1; }
          90% { transform: translateX(0); opacity: 1; }
          100% { transform: translateX(-100px); opacity: 0; }
        }
      `}
              </style>
            </div>
          </div>


          {/* Cards Section */}
          <div
            style={{
              fontFamily: "Epilogue",
              lineHeight: "1.4",
              display: "flex",
              flexWrap: "wrap",
              gap: "20px",
              padding: isMobile ? "20px 10px" : "40px",
              maxWidth: "1200px",
              margin: "auto",
            }}
          >
            {cards.map((card, index) => (
              <div
                key={index}
                style={{
                  width: isMobile
                    ? "100%"
                    : isTablet
                      ? "48%"
                      : "calc((100% - 200px) / 3)", // laptop+ desktop
                  padding: "24px",
                  backgroundColor: "#fff",
                  borderRadius: "16px",
                  fontFamily: "Arial, sans-serif",
                  border: "1px solid #E5E5E5",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textAlign: "left",
                  transition: "transform 0.3s ease-in-out",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                <h2
                  style={{
                    fontSize: isMobile ? "24px" : isTablet ? "28px" : "30px",
                    color: "#222",
                    textAlign: "left",
                  }}
                >
                  {card.title}
                </h2>
                <p
                  style={{
                    fontSize: isMobile ? "12px" : "14px",
                    color: "#666",
                    textAlign: "left",
                    marginBottom: "16px",
                  }}
                >
                  {card.description}
                </p>
                <div style={{ width: "100%" }}>
                  <img
                    src={card.image}
                    alt="Visual Representation"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "16px",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

        </div>

        {/* Compliance Section */}
        {/* <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            padding: "clamp(30px, 5vw, 60px)",
            marginTop: screenWidth <= 1024 ? "clamp(20px, 4vw, 40px)" : "0",
          }}
        >
          <div
            style={{
              maxWidth: "clamp(800px, 90vw, 1200px)",
              margin: "0 auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  color: "#181835",
                  fontSize: "clamp(18px, 2.5vw, 22px)",
                  fontWeight: "bold",
                  paddingLeft: screenWidth <= 1440 ? "clamp(50px, 10vw, 110px)" : "clamp(100px, 12vw, 170px)",
                  alignSelf: "flex-start",
                }}
              >
                Compliance of our company
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "clamp(10px, 2vw, 15px)",
                  marginTop: "clamp(15px, 2vw, 20px)",
                  flexWrap: "wrap",
                }}
              >
                {complianceData.slice(0, 3).map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "#F4F7FF",
                      width: "clamp(200px, 30vw, 270px)",
                      height: "clamp(35px, 5vw, 40px)",
                      padding: "clamp(4px, 1vw, 5px)",
                      borderRadius: "30px",
                      justifyContent: "space-between",
                      cursor: "pointer",
                      transition: "background-color 0.3s, transform 0.3s ease",
                      marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#EDF4FF";
                      e.currentTarget.style.transform = "scale(1.03)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#F4F7FF";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          borderRadius: "50%",
                          padding: "clamp(8px, 1.5vw, 10px)",
                          marginRight: "clamp(8px, 1.5vw, 12px)",
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.title}
                          style={{
                            width: "clamp(30px, 4vw, 40px)",
                            height: "clamp(30px, 4vw, 40px)",
                          }}
                        />
                      </div>
                      <span
                        style={{
                          color: "#181835",
                          fontSize: "clamp(10px, 1.5vw, 12px)",
                          marginRight: "-10px",
                        }}
                      >
                        {item.title}
                      </span>
                    </div>
                    <img
                      src={riarr}
                      alt="Arrow"
                      style={{
                        width: "clamp(14px, 2vw, 18px)",
                        height: "clamp(14px, 2vw, 18px)",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "clamp(10px, 2vw, 15px)",
                marginTop: "clamp(15px, 2vw, 20px)",
                flexWrap: "wrap",
                marginRight: screenWidth <= 1024 ? "clamp(5px, 2vw, 10px)" : "clamp(100px, 20vw, 290px)",
              }}
            >
              {complianceData.slice(3, 5).map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F4F7FF",
                    width: "clamp(200px, 30vw, 270px)",
                    height: "clamp(35px, 5vw, 40px)",
                    padding: "clamp(4px, 1vw, 5px)",
                    borderRadius: "30px",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    transition: "background-color 0.3s, transform 0.3s ease",
                    marginBottom: screenWidth <= 1024 ? "clamp(10px, 2vw, 15px)" : "0",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#EDF4FF";
                    e.currentTarget.style.transform = "scale(1.03)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "#F4F7FF";
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        borderRadius: "50%",
                        padding: "clamp(8px, 1.5vw, 10px)",
                        marginRight: "clamp(8px, 1.5vw, 12px)",
                      }}
                    >
                      <img
                        src={item.icon}
                        alt={item.title}
                        style={{
                          width: "clamp(30px, 4vw, 40px)",
                          height: "clamp(30px, 4vw, 40px)",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        color: "#181835",
                        fontSize: "clamp(10px, 1.5vw, 12px)",
                        marginRight: "-10px",
                      }}
                    >
                      {item.title}
                    </span>
                  </div>
                  <img
                    src={riarr}
                    alt="Arrow"
                    style={{
                      width: "clamp(14px, 2vw, 18px)",
                      height: "clamp(14px, 2vw, 18px)",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* Newsletter Section */}
        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            display: "flex",
            alignItems: "center",
            marginTop: "-20px",
            justifyContent: "center",
            backgroundColor: "#004BA8",
            padding: "clamp(20px, 3vw, 40px) clamp(40px, 5vw, 90px)",
            color: "#fff",
          }}
          className="newsletter-section"
        >
          <div
            style={{
              marginRight: "clamp(20px, 3vw, 40px)",
              marginBottom: "clamp(16px, 2vw, 20px)",
            }}
          >
            <img
              src={news}
              alt="Newsletter"
              style={{
                width: "clamp(150px, 20vw, 200px)",
                height: "clamp(120px, 15vw, 170px)",
                animation: "floatImage 3s ease-in-out infinite",
              }}
            />
          </div>

          <style>
            {`
      @keyframes floatImage {
        0% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
        100% { transform: translateY(0); }
      }

      @media (max-width: 480px) {
        .newsletter-section {
          flex-direction: column;
          text-align: center;
          padding: clamp(16px, 3vw, 24px) clamp(16px, 4vw, 24px);
        }
        .newsletter-section > div:first-child {
          margin-right: 0;
          margin-bottom: clamp(16px, 2vw, 20px);
        }
        .newsletter-section h2,
        .newsletter-section p,
        .newsletter-section > div > div,
        .newsletter-section > div > div:last-child {
          margin-left: 0;
        }
        .newsletter-section .newsletter-input {
          min-width: clamp(200px, 80vw, 260px);
        }
        .newsletter-section button {
        
          display: block;
        }
      }
    `}
          </style>

          <div className="newsletter-content">
                   {/* Title and Paragraph */}
                   <>
                     <style>
                       {`
               .newsletter-text {
                 font-family: Epilogue;
                 line-height: 1.4;
                 font-size: 22px;
                 margin-bottom: 10px;
                 margin-left: 60px;
               }
         
               @media (max-width: 1024px) {
                 .newsletter-text {
                   font-size: 20px;
                   margin-left: 50px;
                 }
               }
         
               @media (max-width: 768px) {
                 .newsletter-text {
                   font-size: 18px;
                   margin-left: 40px;
                 }
               }
         
               @media (max-width: 480px) {
                 .newsletter-text {
                   font-size: 16px;
                   margin-left: 30px;
                 }
               }
             `}
                     </style>
         
                     <div className="newsletter-text">Subscribe to our Newsletter!</div>
                   </>
         
                   <>
                     <style>
                       {`
               .newsletter-description {
                 font-size: 14px;
                 margin-bottom: 20px;
                 text-align: start;
                 margin-left: 60px;
                 max-width: 100%;
                 box-sizing: border-box;
               }
         
               @media (max-width: 1024px) {
                 .newsletter-description {
                   font-size: 13px;
                   margin-left: 50px;
                 }
               }
         
               @media (max-width: 768px) {
                 .newsletter-description {
                   font-size: 12.5px;
                   margin-left: 40px;
                 }
               }
         
               @media (max-width: 480px) {
                 .newsletter-description {
                   font-size: 9px; /* reduced more for small screens */
                   text-align: center;
               
                 }
               }
             `}
                     </style>
         
                     <div className="newsletter-description">
                       Stay updated with our latest news, offers, and insights! Subscribe{" "}
                       <br />
                       for exclusive updates delivered straight to your inbox.
                     </div>
                   </>
         
                   
                 <>
           <style>
             {`
               .input-wrapper {
                 display: flex;
                 align-items: center;
                 position: relative;
                 width: 100%;
                 max-width: 400px;
                 margin: 0 auto 10px auto; /* center aligned */
                 flex-wrap: nowrap;
               }
         
               .email-input {
                 padding: 14px 16px 14px 48px;
                 border-radius: 10px;
                 border: 1px solid #9FCAFF;
                 outline: none;
                 background-color: #00377B;
                 color: #fff;
                 flex: 1;
                 width: 100%;
                 box-sizing: border-box;
                 font-size: 16px;
               }
         
               .email-icon {
                 position: absolute;
                 left: 16px;
                 width: 20px;
                 height: 20px;
               }
         
               /* Optional: Keep consistent appearance on all devices */
               @media (max-width: 480px) {
                 .email-input {
                   padding: 12px 12px 12px 44px;
                   font-size: 14px;
                 }
               }
             `}
           </style>
         
           <div
             style={{
               display: "flex",
               alignItems: "center",
               flexWrap: "wrap",
               justifyContent: "center",
             }}
           >
             <div className="input-wrapper">
               <img src={mail} alt="Email Icon" className="email-icon" />
               <input
                 type="email"
                 value={email}
                 placeholder="sample@gmail.com"
                 className="email-input"
                 onChange={handleChange}
               />
             </div>
           </div>
         </>
         
         
                  
                   <>
                     <style>{`
                 .captcha-container {
                   display: flex !important;
                   align-items: center !important;
                   justify-content: center !important;
                   margin: 10px auto !important;
                   border-radius: 20px !important;    
                   gap: 8px !important;
                   flex-wrap: wrap !important;
                 }
               .captcha-box {
           width: 60px !important;
           height: 40px !important;
           border-radius: 8px !important;
           background-color: #fff !important;
           box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
           display: flex !important;
           align-items: center !important;
           justify-content: center !important;
           overflow: hidden !important; /* Add this to clip canvas overflow */
         }
         
         #captchaCanvas {
           border-radius: 20px !important;
         }
                 .captcha-input {
                   padding:10px 1px!important;
                   border-radius:8px!important;
                   border:1px solid #ccc!important;
                   outline:none!important;
                   min-width:120px!important;
                   background:#00377B!important;
                   color:#fff!important;
                 }
                 .subscribe-button {
                   padding:14px 30px!important;
                   border-radius:12px!important;
                   border:none!important;
                   background:#fff!important;
                   color:#0A3A72!important;
                   font-weight:bold!important;
                   cursor:pointer!important;
                   margin-bottom:0!important;
                 }
                 @media(max-width:1024px){ .captcha-container{margin-left:50px!important;} .captcha-input{min-width:110px!important;} }
                 @media(max-width:768px ){ .captcha-container{margin-left:40px!important;} .captcha-input{min-width:100px!important;} }
                 @media(max-width:480px ){ .captcha-container{margin-left:20px!important;margin-right:20px!important;gap:4px!important;} .captcha-input{min-width:80px!important;font-size:14px!important;} }
               `}</style>
         
                     <div className="captcha-container">
                       <div className="captcha-box">
                         <canvas
                           ref={canvasRef}
                           id="captchaCanvas"
                           width={60}
                           height={40}
                         />
                       </div>
         
                       <button
                         onClick={handleReload}
                         style={{
                           background: "#2563EB",
                           color: "#fff",
                           border: "none",
                           padding: "8px",
                           borderRadius: "8px",
                           cursor: "pointer",
                           display: "flex",
                           alignItems: "center",
                           justifyContent: "center",
                         }}
                       >
                         {/* Your reload SVG icon here */}
                         <svg
                           xmlns="http://www.w3.org/2000/svg"
                           width="22"
                           height="22"
                           viewBox="0 0 24 24"
                           fill="none"
                           stroke="white"
                           strokeWidth="2"
                           strokeLinecap="round"
                           strokeLinejoin="round"
                         >
                           <polyline points="23 4 23 10 17 10"></polyline>
                           <polyline points="1 20 1 14 7 14"></polyline>
                           <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                         </svg>
                       </button>
         
                       <input
                         type="text"
                         placeholder="Enter captcha"
                         value={userCaptcha}
                         onChange={(e) => setUserCaptcha(e.target.value)}
                         className="captcha-input"
                       />
         
                       <button className="subscribe-button" onClick={handleSubscribe}>
                         Subscribe
                       </button>
                     </div>
                   </>
         
                   {/* Note */}
                   <div
                     style={{
                       fontSize: "12px",
                       marginTop: "10px",
                       color: "#fff",
                       marginLeft:
                         window.innerWidth <= 480
                           ? "20px"
                           : window.innerWidth <= 768
                           ? "40px"
                           : window.innerWidth <= 1024
                           ? "50px"
                           : "60px",
                     }}
                   >
                     *Unsubscribe anytime. We don’t send any spam
                   </div>
                 </div>
        </div>

        {/* Footer */}
     <div
  style={{
    fontFamily: "Epilogue",
    lineHeight: "1.4",
    display: "flex",
    justifyContent: "space-between",
    padding: isMobile ? "20px 10px" : "40px",
    backgroundColor: "#fff",
    flexWrap: "wrap",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  }}
>
  <div
    style={{
      maxWidth: isMobile ? "100%" : isTablet ? "50%" : "300px",
      marginBottom: "40px",
    }}
  >
    <Link to="/">
      <img
        src={logo}
        alt="Mawalog"
        style={{
          width: isMobile ? "150px" : "180px",
          height: "auto",
          display: "flex",
          justifyContent: "start",
          cursor: "pointer"  // shows it's clickable
        }}
      />
    </Link>
    <p
      style={{
        color: "#555",
        fontSize: isMobile ? "12px" : "14px",
        lineHeight: "1.6",
        textAlign: "start",
        marginBottom: isMobile ? "20px" : "100px",
      }}
    >
      At Mawalog, we believe in simplifying the complexities of supply chain
      management by offering an integrated platform that combines manufacturing,
      logistics, and warehouse solutions partner with optimized logistics and a
      global network.
    </p>
    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: isMobile ? "0" : "-80px",
      }}
    >
      {[insta, face, youtube, link,twit].map((icon, index) => (
        <img
          key={index}
          src={icon}
          alt={`icon-${index}`}
          style={{
            width: isMobile ? "20px" : "24px",
            height: isMobile ? "20px" : "24px",
            cursor: "pointer",
            transition: "transform 0.3s ease",
            transformOrigin: "center",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.4)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "scale(1)")
          }
          onClick={() => {
            if (icon === face)
              window.open("https://www.facebook.com/mawalogone/", "_blank");
            if (icon === youtube)
              window.open("https://www.youtube.com/@mawalogone", "_blank");
            if (icon === insta)
              window.open("https://www.instagram.com/mawalogone/", "_blank");
            if (icon === link)
              window.open(
                "https://www.linkedin.com/company/mawalogone/",
                "_blank"
              )
              if (icon === twit)
              window.open("https://x.com/mawalogone", "_blank");
          }}
        />
      ))}
    </div>
  </div>

  <div
  style={{
    display: "flex",
    gap: isMobile ? "20px" : isTablet ? "40px" : "60px",
    flexWrap: "wrap",
    justifyContent: isMobile ? "flex-start" : "space-between",
  }}
>
  <div>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
      }}
    >
      Know More
    </h4>
{["Opportunities", "Articles", "Our Story", "Help Center"].map(
  (item, index) => (
    <p
      key={index}
      style={{
        margin: "8px 0",
        color: "#555",
        cursor: "pointer",
        textAlign: "start",
        fontSize: isMobile ? "12px" : "14px",
        transition: "color 0.3s ease",
        paddingBottom: "2px",
      }}
      onClick={() => {
        switch (item) {
          case "Opportunities":
          case "Articles":
          case "Help Center":
            navigate("/coming");
            break;
          case "Our Story":
            navigate("/about");
            break;
        }
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = "#3B82F6";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = "#555";
      }}
    >
      {item}
    </p>
  )
)}

  </div>

 <div>
      <h4
        style={{
          fontSize: isMobile ? "12px" : "14px",
          fontWeight: "bold",
          marginRight: isMobile ? "0" : "20px",
        }}
      >
        Legal &amp; Policies
      </h4>

 {[
  "Terms and Conditions",
  "Privacy Policy",
  "Cookie Policy",
  "Copyright Policy",
].map((item, index) => (
  <p
    key={index}
    style={{
      margin: "8px 0",
      color: "#555",
      cursor: "pointer",
      textAlign: "start",
      fontSize: isMobile ? "12px" : "14px",
      transition: "color 0.3s ease",
      paddingBottom: "2px",
    }}
    onClick={() => {
      const targetId = `#${item.toLowerCase().replace(/\s+/g, "-")}`;
      const basePath =
        item === "Terms and Conditions"
          ? "/terms"
          : item === "Privacy Policy"
          ? "/policy"
          : item === "Cookie Policy"
          ? "/cookie"
          : item === "Copyright Policy"
          ? "/copyright"
          : "/";
      navigate(`${basePath}${targetId}`);
    }}
    onMouseEnter={(e) => (e.currentTarget.style.color = "#3B82F6")}
    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
  >
    {item}
  </p>
))}

    </div>

</div>


  <div style={{ marginBottom: "40px" }}>
    <h4
      style={{
        fontSize: isMobile ? "12px" : "14px",
        fontWeight: "bold",
        marginRight: isMobile ? "0" : "180px",
      }}
    >
      Contact us
    </h4>
    <a
      href="https://mail.google.com/mail/?view=cm&to=info@mawalog.com"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#004BA8",
        cursor: "pointer",
        fontSize: isMobile ? "12px" : "14px",
        textAlign: "start",
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={ee}
        alt="Email"
        style={{
          width: isMobile ? "12px" : "14px",
          height: isMobile ? "12px" : "14px",
          marginRight: "8px",
        }}
      />
      info@mawalog.com
    </a>
    {[
      { phone: "603-27700-311", country: "Malaysia" },
      { phone: "+971-50-1234567", country: "UAE" },
      { phone: "+44 7911 123456", country: "UK" },
      { phone: "+91-44-4856-3345", country: "India" },
    ].map((contact, index) => (
      <p
        key={index}
        style={{
          fontSize: isMobile ? "12px" : "14px",
          textAlign: "start",
        }}
      >
        <img
          src={phone}
          alt="Phone"
          style={{
            width: isMobile ? "12px" : "14px",
            height: isMobile ? "12px" : "14px",
            marginRight: "8px",
          }}
        />
        <a
          href={`tel:${contact.phone}`}
          style={{
            color: "#004BA8",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          {contact.phone}
        </a>{" "}
        (<span style={{ color: "#000" }}>{contact.country}</span>)
      </p>
    ))}
  </div>

  <div
    className="flex flex-col items-center justify-center p-6 rounded-2xl bg-gradient-to-br from-gray-900 to-purple-700 text-white max-w-sm mx-auto shadow-lg"
    style={{ marginBottom: "40px", position: "relative" }}
  >
    <div style={{ position: "relative", display: "inline-block" }}>
      <a
        href="https://app.mawalog.com/register"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={trial}
          alt="Illustration"
          style={{
            width: isMobile ? "180px" : isTablet ? "200px" : "210px",
            height: "auto",
            display: "block",
            cursor: "pointer",
          }}
        />
      </a>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "-100%",
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(130deg, transparent 48%, rgba(255,255,255,0.4) 50%, transparent 52%)",
            animation: "shine 3s ease-in-out infinite",
          }}
        ></div>
      </div>
    </div>
    <style>
      {`
        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}
    </style>
  </div>
</div>
       

        <div
          style={{
            fontFamily: "Epilogue",
            lineHeight: "1.4",
            textAlign: "center",
            padding: isMobile ? "15px 0" : "20px 0",
            borderTop: "1px solid #ddd",
            fontSize: isMobile ? "12px" : "14px",
            color: "#333",
          }}
        >
          Copyright © 2025. <strong>MAWALOG</strong>. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Sayhello;